import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/ui';

interface NewProps {
    onIssue: () => void;
    canIssue: boolean;
}

/** EAA-1820 (frame 33): realm/search genuinely has zero accounts. */
export function AccountsEmptyNew({ onIssue, canIssue }: NewProps) {
    const { t } = useTranslation();
    return (
        <EmptyState
            title={t('console.accounts.emptyState.newTitle')}
            description={t('console.accounts.emptyState.newDescription')}
            action={
                canIssue ? (
                    <button type="button" className="portal-btn portal-btn-primary" onClick={onIssue}>
                        {t('console.accounts.emptyState.issueButton')}
                    </button>
                ) : undefined
            }
        />
    );
}

interface FilteredProps {
    search: string;
    onClear: () => void;
}

/** EAA-1820 (frame 33): a search/filter combination matched nothing — this is
 *  a DIFFERENT state from `AccountsEmptyNew` and offers a different action
 *  (clear the filter, not create an account), per the ticket's brief. */
export function AccountsEmptyFiltered({ search, onClear }: FilteredProps) {
    const { t } = useTranslation();
    return (
        <EmptyState
            title={t('console.accounts.emptyState.filteredTitle')}
            description={
                search
                    ? t('console.accounts.emptyState.filteredDescriptionWithSearch', { search })
                    : t('console.accounts.emptyState.filteredDescription')
            }
            action={
                <button type="button" className="portal-btn" onClick={onClear}>
                    {t('console.accounts.emptyState.clearFiltersButton')}
                </button>
            }
        />
    );
}
